import React from 'react';
import { WrappedCard } from '../WrappedCard';
import { wrappedCopy } from '../../../lib/wrapped/wrappedCopy';

interface NextYearCardProps {
  totalWingoMined: number;
  daisyTrustScore: number;
  avatarUrl?: string;
  username?: string;
  rank?: number;
}

export const NextYearCard: React.FC<NextYearCardProps> = ({
  totalWingoMined,
  daisyTrustScore,
  avatarUrl,
  username,
  rank,
}) => {
  // Calculate future projection
  // Top 3: previous period x 2
  // Everyone else: previous period x 3-5 (deterministic based on username)
  let projectedWingo: number;
  let multiplier: number;
  
  if (rank !== undefined && rank <= 3) {
    multiplier = 2;
    projectedWingo = totalWingoMined * 2;
  } else {
    // Deterministic multiplier between 3 and 5 based on username hash
    // This ensures the same user always gets the same multiplier
    const usernameHash = username ? username.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) : 0;
    multiplier = 3 + (usernameHash % 200) / 100; // 3.0 to 5.0
    projectedWingo = Math.round(totalWingoMined * multiplier);
  }

  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-3 md:space-y-4 relative z-10">
        {/* User avatar */}
        {avatarUrl && (
          <div className="flex justify-center mb-3 md:mb-4">
            <img
              src={avatarUrl}
              alt="User avatar"
              className="w-32 h-32 md:w-36 md:h-36 rounded-full object-cover border-4 border-yellow-400 shadow-2xl"
              style={{ objectPosition: 'center top' }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/avatars/default.png';
              }}
            />
          </div>
        )}
        
        <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent mb-3 md:mb-4 drop-shadow-2xl text-center">
          Future Projection
        </h2>
        <div className="text-6xl md:text-7xl mb-3 md:mb-4 text-center">🔮</div>
        <div className="bg-black/60 backdrop-blur-md rounded-2xl p-4 md:p-5 border-2 border-yellow-400/50 shadow-2xl">
          <div className="text-5xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent text-center break-words">
            {projectedWingo.toLocaleString()} WINGO
          </div>
        </div>
      </div>
    </WrappedCard>
  );
};

